/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import { useState } from 'react';
import { useParams } from 'react-router-dom';
import Dashboard, { DashboardSection } from '@g17eco/molecules/dashboard';
import LoadingButton from '@g17eco/molecules/button/LoadingButton';
import NotAuthorised from '@routes/not-authorised';
import { useAppSelector } from '@reducers/index';
import { isStaff } from '@selectors/user';
import { RunsList } from '../../components/intelligence/insights-synthesis/RunsList';
import { CreateRunModal } from '@apps/company-tracker/components/intelligence/insights-synthesis/CreateRunModal';

interface RouteParams {
  initiativeId: string;
}

export const InsightsSynthesisListRoute = () => {
  const { initiativeId } = useParams<RouteParams>();
  const isUserStaff = useAppSelector(isStaff);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  if (!isUserStaff) {
    return <NotAuthorised />;
  }

  const headerButtons = [
    <LoadingButton key='new-run' color='primary' onClick={() => setIsCreateModalOpen(true)}>
      <i className='fa fa-plus me-1' /> Start New Run
    </LoadingButton>,
  ];

  return (
    <Dashboard>
      <DashboardSection
        title='Insights Synthesis'
        subtitle='Manage AI-generated insight synthesis runs and review generated insights.'
        buttons={headerButtons}
      >
        <RunsList initiativeId={initiativeId} />
      </DashboardSection>

      <CreateRunModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        initiativeId={initiativeId}
      />
    </Dashboard>
  );
};
